export function getRawText(input: string): string {
  // Strip HTML tags and decode HTML entities if necessary
  const rawText = input.replace(/<\/?[^>]+(>|$)/g, "");

  // Get the first 200 characters
  return rawText.slice(0, 200);
}
